import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { OsobaTelefon } from './osoba-telefon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-osoba-telefon-modal-update',
  templateUrl: './osoba-telefon-modal-update.component.html'
})
export class OsobaTelefonModalUpdateComponent extends BaseModalUpdateComponent<OsobaTelefon> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsobaTelefon>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
